import React, { useEffect, useState } from "react";
import Casino from "./../../assets/images/casino.svg";
import Sports from "./../../assets/images/sports.svg";
import FullSite from "./../../assets/images/full-site.svg";
import WalletSvg from "./../../assets/images/wallet.svg";
import MatkaLogo from "../../assets/images/matka.png";
import Home from "../../assets/images/strikelogo2.svg";
import Promotions from "../../assets/images/promotion.svg";
import { domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/whitelabelEnv";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../models/RootState";
import { SiteConfig } from "../../models/SiteConfig";
import { DEFAULT_MATKA_FUN_GAME_INFO, DEFAULT_MATKA_LIVE_GAME_INFO, MATKA_FUN_GAME_ID, MATKA_LIVE_GAME_ID } from "../../constants/games";
import MatkaFunIcon from "../../assets/images/matka-fun.svg";
import MatkaLiveIcon from "../../assets/images/matka-play.svg";

const WhiteLabelLogo = getEnvVariable(domain, 'logo');
const BrandName = getEnvVariable(domain, 'BRAND_NAME');
const showSites = typeof BrandName === 'string' && BrandName.toLowerCase() !== 'winfast99' && (BrandName.toLowerCase() === 'hindu777' || BrandName.toLowerCase() === 'lotus365');

type FooterItem = {
  icon: string | React.ComponentType<any>;
  label: string;
  path: string;
  /**
   * Returns true if the item should be shown (enabled)
   */
  isEnabled?: (siteConfig: SiteConfig) => boolean;
};

const footerItems: FooterItem[] = [
  {
    icon: Casino,
    label: "Casino",
    path: "casino",
    isEnabled: (siteConfig) => siteConfig.isCasinoEnabled, // show if casino is enabled
  },
  {
    icon: MatkaFunIcon,
    label: "Matka Fun",
    path: "game",
    isEnabled: () => true, // show if casino is enabled
  },
  // {
  //   icon: Sports,
  //   label: "Sports",
  //   path: "sports",
  //   isEnabled: (siteConfig) => siteConfig.isSportsEnabled, // show if sports is enabled
  // },
  {
    icon: MatkaLiveIcon,
    label: "Matka Live",
    path: "game",
    isEnabled: () => true, // always enabled
  },
  // {
  //   icon: showSites ? FullSite : Promotions,
  //   label: showSites ? "Sites" : "Promos",
  //   path: "promotions",
  //   isEnabled: () => true,
  // },
  {
    icon: WalletSvg,
    label: "Wallet",
    path: "wallet",
    isEnabled: () => true,
  },
];

const Footer: React.FC = () => {
  const [activeTab, setActiveTab] = useState("Home");
  const navigate = useNavigate();
  const location = useLocation();

  const siteConfig = useSelector(
    (state: RootState) => state.userDetails.siteConfig
  );

  const handleItemClick = (tab: FooterItem) => {
    setActiveTab(tab.label);
    // For Matka Fun, pass gameId via state
    if (tab.label === "Matka Fun") {
      const gameInfo = btoa(DEFAULT_MATKA_FUN_GAME_INFO);
      navigate("/" + tab.path, { state: { gameInfo } });
    } else if (tab.label === "Matka Live") {
      // For Matka Live, use default or pass explicitly
      const gameInfo = btoa(DEFAULT_MATKA_LIVE_GAME_INFO);
      navigate("/" + tab.path, { state: { gameInfo } });
    } else {
      navigate("/" + tab.path);
    }
  };

  useEffect(() => {
    const currentItem = footerItems.find((item) =>
      location.pathname.includes(item.path)
    );
    if (currentItem && location.pathname.includes("game")) {
      // Check if gameInfo is in state to determine which matka game is active
      const gameInfoFromState = (location.state as any)?.gameInfo;
      if (gameInfoFromState) {
        try {
          const decodedGameInfo = atob(gameInfoFromState);
          const gameId = decodedGameInfo.split(":")[0];
          if (gameId === MATKA_FUN_GAME_ID) {
            setActiveTab("Matka Fun");
          } else if (gameId === MATKA_LIVE_GAME_ID) {
            setActiveTab("Matka Live");
          } else {
            // Default to Matka Live if gameId doesn't match
            setActiveTab("Matka Live");
          }
        } catch (e) {
          // Default to Matka Live on error
          setActiveTab("Matka Live");
        }
      } else {
        // No state means default (Matka Live)
        setActiveTab("Matka Live");
      }
    } else if (currentItem) {
      setActiveTab(currentItem.label);
    }
  }, [location]);

  // ✅ Filter only enabled footer items
  const enabledFooterItems = footerItems.filter((item) => {
    if (typeof item.isEnabled === "function") {
      return item.isEnabled(siteConfig);
    }
    return item.isEnabled !== false; // default true
  });

  return (
    <footer
      // Avoid CSS transforms here: transforms create a new compositing layer and can cause
      // iframes to "win" click/paint ordering in some browsers/emulation modes.
      // Keep above iframe, but below MUI Dialog (z-index 1300)
      className={`fixed bottom-0 left-0 right-0 mx-auto w-[calc(100%-1rem)] md:w-[95%] text-sm md:max-w-[25rem] font-medium rounded-2xl border-b-0 border border-border-color text-zinc-400 flex flex-col px-5 py-2 justify-center z-[1000]`}
      style={{
        background:
          "linear-gradient(to top, rgba(5,19,20), rgba(5,19,20,0.8))",
      }}
    >
      <nav className="flex gap-5 justify-between">
        {enabledFooterItems.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col text-center whitespace-nowrap ${item.label === activeTab
              ? "text-border-color"
              : "text-text-color"
              }`}
            onClick={() => handleItemClick(item)}
            style={{ cursor: "pointer" }}
          >
            {typeof item.icon === 'string' ? (
              <img
                loading="lazy"
                src={item.icon}
                alt={item.label}
                className={`self-center ${item.label === "Promos"
                  ? "aspect-[1.45] w-[26px]"
                  : item.label === "Wallet"
                    ? "w-5 rounded-lg aspect-[1.11]"
                    : item.label === "Home"
                      ? "w-[48px]"
                      : "aspect-square w-[18px]"
                  }`}
                style={{
                  filter:
                    item.label === activeTab
                      ? (item.label !== "Home" ? 'var(--filter-color)' : 'none')
                      : item.label !== "Home"
                        ? "brightness(0) saturate(100%) invert(69%) sepia(0%) saturate(923%) hue-rotate(219deg) brightness(101%) contrast(99%)"
                        : "none",
                  height: item.label === "Home" ? '22px' : '',
                }}
              />
            ) : (
              <item.icon
                className="self-center"
                style={{
                  fontSize: '18px',
                  color: item.label === activeTab
                    ? 'var(--border-color)'
                    : 'var(--text-color)',
                }}
              />
            )}
            <div className={`${item.label === "Home" ? "mt-1" : "mt-2"}`}>
              {item.label}
            </div>
          </div>
        ))}
      </nav>
    </footer>
  );
};

export default Footer;
